import { FC, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { AuscultationPointListItem } from '@higo/common/src/components/Auscultation/AuscultationPointListItem';
import {
  ExaminationPageDiagnosisModel,
  ExaminationPagePatientModel,
} from '@higo/common/src/features/ExaminationPage/models';
import {
  useLungsAuscultationPhysicalExaminationQuery,
  useLungsAuscultationPhysicalExaminationResourceFiles,
} from '@higo/common/src/features/ExaminationPage/hooks/queries';
import styled from 'styled-components';
import { media } from '@higo/ui';

export interface LiveVisitLungsAsculationSectionProps {
  examinationId: number;
  diagnosisModel?: ExaminationPageDiagnosisModel;
  patientModel: ExaminationPagePatientModel;
  point: any;
  anteriorLungs?: boolean;
  posteriorLungs?: boolean;
}

const AuscultationGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 0;
  margin: 0;
  ${media.mobile.max} {
    gap: 0.5rem;
  }
`;

export const LiveVisitLungsAsculationSection: FC<LiveVisitLungsAsculationSectionProps> =
  ({ point, patientModel, anteriorLungs, posteriorLungs }) => {
    const intl = useIntl();
    const { data, refetch } = useLungsAuscultationPhysicalExaminationQuery(
      point.examId,
    );

    const specificPointData = data?.lungsResults.filter(
      (item) => item.pointer?.toString() === point.auscultationPointIndex,
    );

    const specificPointFileId =
      specificPointData && specificPointData[0] && specificPointData[0].fileId;

    const { data: fileResourceMap } =
      useLungsAuscultationPhysicalExaminationResourceFiles(point.examId);

    let specificPointFileResourceMap;

    for (let key in fileResourceMap) {
      if (
        specificPointFileId &&
        fileResourceMap[key].fileId &&
        fileResourceMap[key].fileId === specificPointFileId
      ) {
        specificPointFileResourceMap = fileResourceMap[key];
        break;
      }
    }
    const label = `${intl.formatMessage({
      id: 'common.point',
    })}  ${point.auscultationPointIndex}`;

    const tagline = intl.formatMessage({
      id: point.auscultationPointIndex % 2 ? 'common.right' : 'common.left',
    });

    useEffect(() => {
      refetch();
    }, [point]);

    return (
      <>
        <AuscultationGroupContainer>
          {fileResourceMap && specificPointFileId && (
            <AuscultationPointListItem
              id={point.auscultationPointIndex}
              key={point.auscultationPointIndex}
              tagline={tagline}
              label={label}
              file={specificPointFileResourceMap}
            />
          )}
        </AuscultationGroupContainer>
      </>
    );
  };
